import React, { useState } from "react";

// components imports
import UnitsTable from "../../../../../Components/BoltTable/BoltTable";
import CompanyDetails from "../../Components/CompanyDetails/CompanyDetails";
import UpdateDetails from "../../Components/UpdateDetails/UpdateDetails";
import Tooltip from "../../../../../Components/Tooltip/Tooltip";

// apis imports
import { fetchCompaniesDetails } from "../../../../../services/admin.services";
// library imports
import noImage from "../../../../../assets/images/noImage.png";
import Flag from "react-world-flags";
import { MdRemoveRedEye } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const LandingCompanyDetails = ({ setSnack }) => {
  const { t } = useTranslation("admin");
  const [companyDetails, setCompanyDetails] = useState([]);
  const [companyDetailsModal, setCompanyDetailsModal] = useState();
  const [updateDetailsModal, setUpdateDetailsModal] = useState();

  const columns = [
    {
      id: 1,
      label: t("newsletter.logo"),
      render: (row) => (
        <>
          <img
            src={row?.logo_url ?? noImage}
            onError={(e) => {
              e.target.src = noImage;
            }}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 2,
      label: t("newsletter.name"),
      render: (row) => <>{row?.name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("newsletter.about"),
      render: (row) => (
        <>{row.rating_setting ? row.rating_setting[1]?.description : "-"}</>
      ),
      width: "250px",
    },
    {
      id: 4,
      label: t("newsletter.history"),
      render: (row) => (
        <>{row.rating_setting ? row.rating_setting[0]?.description : "-"}</>
      ),
      width: "250px",
    },
    {
      id: 5,
      label: t("newsletter.countries"),
      render: (row) => (
        <>
          {row?.rating_country ? (
            <div className="custabscreen__theader_cntryflags">
              {row?.rating_country?.map((country) => (
                <div className="custabscreen__theader_flagwrap">
                  <Flag
                    code={country?.name}
                    fallback={<span>--</span>}
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  />
                </div>
              ))}
            </div>
          ) : (
            "-"
          )}
        </>
      ),
      width: "200px",
    },
    {
      id: 6,
      label: t("newsletter.actions"),
      render: (row) => (
        <div className="table_action__wrap">
          <Tooltip title={t("newsletter.viewCompanyDetails")}>
            <div
              className="table_action__btn"
              onClick={() => setCompanyDetailsModal(row)}
            >
              <MdRemoveRedEye size={10} />
              {t("newsletter.details")}
            </div>
          </Tooltip>
          <Tooltip title={t("newsletter.editCompanyDetails")}>
            <div
              className="table_action__btn"
              onClick={() => setUpdateDetailsModal(row)}
            >
              <FaRegEdit size={10} />
              {t("common:actions.edit")}
            </div>
          </Tooltip>
        </div>
      ),
      width: "200px",
    },
  ];

  const getCompanyDetails = async (page, perPage, filter) => {
    const response = await fetchCompaniesDetails(page, perPage, filter);
    if (!response.error) {
      setCompanyDetails(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  return (
    <>
      <CompanyDetails
        open={!!companyDetailsModal}
        companyData={companyDetailsModal}
        setOpen={setCompanyDetailsModal}
      />
      <UpdateDetails
        open={!!updateDetailsModal}
        companyData={updateDetailsModal}
        setOpen={setUpdateDetailsModal}
        setSnack={setSnack}
        setCompanyDetails={setCompanyDetails}
      />
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <UnitsTable
          tableTitle={t("newsletter.landingCompanyDetails")}
          tableId="landingCompanyDetailsTableForAdminNewsletter"
          message={t("newsletter.noLandingCompanyAvailableTo")}
          searchPlaceHolder={t("newsletter.searchLandingCompanies")}
          columns={columns}
          data={companyDetails}
          getAllData={getCompanyDetails}
        />
      </div>
    </>
  );
};

export default LandingCompanyDetails;
